import React from 'react';
import {useState} from "react";
import 'bootstrap/dist/css/bootstrap.min.css'
import { Line } from 'react-chartjs-2';
import DateTimePicker from 'react-datetime-picker';

function graphOverTime(){
    // eslint-disable-next-line react-hooks/rules-of-hooks
   const [startDate, setStartDate] = useState(new Date());
    // eslint-disable-next-line react-hooks/rules-of-hooks
   const [endDate, setEndDate] = useState(new Date());
   // create a state for the data
    // eslint-disable-next-line react-hooks/rules-of-hooks
   const [temp, setTemp] = useState([]);
   // create a state for the data
    // eslint-disable-next-line react-hooks/rules-of-hooks
   const [humidity, setHumidity] = useState([]);
   
    // eslint-disable-next-line react-hooks/rules-of-hooks
   const [chartData, setChartData] = useState({
        labels: [1,2,3,4,5],
        datasets: [
            {
                label: 'Temperature',
                data: [1,2,3,4,5],
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                borderColor: 'rgba(255, 99, 132, 1)',
                borderWidth: 1
            },
            {
                label: 'Humidity',
                data: [1,2,3,4,5],
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                borderColor: 'rgba(54, 162, 235, 1)',
                borderWidth: 1
            }
        ]
    });
   
   // fetch the data from the server depending on the start and end date
    const fetchTemp = async () => {
        // start date in YYYY-MM-DD format
        const start = startDate.toISOString().substring(0,10);
        // end date in YYYY-MM-DD format
        const end = endDate.toISOString().substring(0,10);
        const response = await fetch(`https://iot-temphumid.herokuapp.com/temperature?start=${start}&end=${end}`, {
            credentials: 'include'
        });
        const data = await response.json();
       
        setTemp(data);
    }
    
    const fetchHumidity = async () => {
        // start date in YYYY-MM-DD format
        const start = startDate.toISOString().substring(0,10);
        // end date in YYYY-MM-DD format
        const end = endDate.toISOString().substring(0,10);
        const response = await fetch(`https://iot-temphumid.herokuapp.com/humidity?start=${start}&end=${end}`,{
            credentials: 'include'
        });
        const data = await response.json();
        setHumidity(data);
    }
    
    // handleSubmit is called when the user clicks the submit button
    const handleSubmit = (event) => {
        event.preventDefault();        
        // fetch temp  and humidity data  then call the updateChart function
        fetchTemp();
        fetchHumidity();
        updateChart();
    }
    
    // updateChart is called when the user clicks the submit button
    const updateChart = () => {
        // create the data for the line chart
        // get temp
        const tempData = temp.map(item => item.temperature);
        // get humidity
        const humidityData = humidity.map(item => item.humidity);
        // get the labels
        const labels = temp.map(item => item.taken_at);
        
        const data = {
            //smooth the line
            lineTension: 0,
            labels: labels,
            datasets: [
                {
                    label: 'Temperature',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(75,192,192,0.4)',
                    borderColor: 'rgba(75,192,192,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(75,192,192,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: tempData,
                },
                {
                    label: 'Humidity',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(75,192,192,0.4)',
                    borderColor: 'rgba(75,192,192,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(75,192,192,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: humidityData,
                }
            ]
        };
        // update the line chart
        setChartData(data);
    }
    
    return (
        <div>
            <form onSubmit={handleSubmit}>
                <div className="form-group m-1">
                    <label className="m-lg-3">Start Date</label>
                    <DateTimePicker
                        format={'yyyy-MM-dd'}
                        onChange={(date) => setStartDate(date)}
                        value={startDate}
                    />
                </div>
                <div className="form-group m-1">
                    <label className="m-lg-3">End Date</label>
                    <DateTimePicker
                        format={'yyyy-MM-dd'}
                        onChange={(date) => setEndDate(date)}
                        value={endDate}
                    />
                </div>
                <button type="submit" onSubmit={handleSubmit} className="btn btn-primary m-lg-3">Submit</button>
            </form>
            <Line data={chartData}/>
        </div>
    )
}

export default graphOverTime;